<script setup>
import Multiselect from "vue-multiselect";
import {inject} from "vue";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();
const tracker = inject('tracker');
const canEditInfo = inject('canEditInfo');
</script>

<template>
    <div>
        <h5 class="heading5 heading5--secondary">Categories</h5>
        <div class="mb-4">
            <Multiselect
                v-model="tracker.categories"
                class="multiselect-mid multiselect-modern"
                :options="store.state.categories"
                :multiple="true"
                select-label=""
                deselect-label=""
                :disabled="!canEditInfo"
                label="name"
                track-by="name"
            />
        </div>
    </div>
</template>

<style scoped>

</style>
